import React from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import styles from "./TaskOverview.module.css";
import { turnacatedTaskName, formatDuration } from "./../../helpers/stubs";

const calculateTime = (time, totalWorkDuration) => {
  return (time / totalWorkDuration) * 100;
};

function TaskOverview({ taskList, currentTask, totalWorkDuration }) {
  console.log("total work Duration :- ", totalWorkDuration);
  return (
    <div className={`text-center ${styles.taskview}`}>
      <Row>
        <Row>
          <Col>Tasks</Col>
        </Row>
        <div className={`${styles.tasks}`}>
          {taskList.map((task) => (
            <Row className="pe-0">
              {currentTask && currentTask._id === task._id ? (
                <>
                  <Col
                    sm="9"
                    className={`pe-0 text-start text-break ${
                      styles.currentTask
                    } ${task.type === "offline" ? "text-danger" : "text-body"}`}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="button-tooltip-2">
                          {`${task.name} > ${task.project} > ${task.supervisingClient}`}
                        </Tooltip>
                      }
                    >
                      {({ ref, ...triggerHandler }) => {
                        return (
                          <div {...triggerHandler}>
                            <div ref={ref}>
                              <i className="bi bi-caret-right-fill ms-1" />
                              <span style={{ fontSize: "14px" }}>
                                {turnacatedTaskName(
                                  task.name,
                                  task.project,
                                  task.supervisingClient
                                )}
                              </span>
                              {task.type === "offline" && (
                                <span className="text-body"> (offline)</span>
                              )}
                            </div>
                          </div>
                        );
                      }}
                    </OverlayTrigger>
                  </Col>
                  <Col sm="3" className={`p-0 text-end ${styles.currentTask}`}>
                    {formatDuration(task.duration)}
                    <div
                      className={`${
                        task.type === "offline"
                          ? styles.offlineProgressBar
                          : styles.progressBar
                      }`}
                      style={{
                        width: `${calculateTime(
                          task.duration,
                          totalWorkDuration
                        )}px`,
                      }}
                    />
                  </Col>
                </>
              ) : (
                <Row className="pe-0">
                  <Col
                    sm="9"
                    className={`pe-0 text-start text-break ${
                      task.type === "offline" ? "text-danger" : "text-body"
                    }`}
                  >
                    <OverlayTrigger
                      placement="top-start"
                      overlay={
                        <Tooltip id="button-tooltip-2">
                          {`${task.name} > ${task.project} > ${task.supervisingClient}`}
                        </Tooltip>
                      }
                    >
                      {({ ref, ...triggerHandler }) => {
                        return (
                          <>
                            <div {...triggerHandler} ref={ref}>
                              <span
                                ref={ref}
                                className="ms-2"
                                style={{ fontSize: "14px" }}
                              >
                                {turnacatedTaskName(
                                  task.name,
                                  task.project,
                                  task.supervisingClient
                                )}
                              </span>
                              {task.type === "offline" && (
                                <span className="text-body"> (offline)</span>
                              )}
                            </div>
                          </>
                        );
                      }}
                    </OverlayTrigger>
                  </Col>
                  <Col sm="3" className="p-0 text-end">
                    {formatDuration(task.duration)}
                    <div
                      className={`${
                        task.type === "offline"
                          ? styles.offlineProgressBar
                          : styles.progressBar
                      }`}
                      style={{
                        width: `${calculateTime(
                          task.duration,
                          totalWorkDuration
                        )}px`,
                      }}
                    />
                  </Col>
                  
                </Row>
              )}
            </Row>
          ))}
        </div>
      </Row>
    </div>
  );
}

export default TaskOverview;
